import $ from "jquery"
import formatter from "../model/formatter"
import deepEqual from "deep-equal"
import Hook from "../hook"

/** Ignore these forms when setting datefilters */
const ignoreDateFilter = [
  "Core.EmailTemplate",
  "Core.Settings",
  "Core.Record",
  "Settings.Period",
  "Core.ImageFormat",
  "Customer.CustomerGroup",
  "Customer.Contact",
  "Rental.Item",
  "Sales.Item",
  "Rental.ItemGroup",
  "Sales.ItemGroup",
  "Rental.Outputpackaging",
  "Sales.Outputpackaging",
  "Rental.ItemPeriod",
  "Sales.Affiliate",
  "Settings.VAT",
  "Sales.ItemVAT",
  "Warehouse.Warehouse",
  "Warehouse.Location",
  "Rental.ServiceType",
]

/**
 * Set selected filter
 * @param {Window} window - Window
 * @returns {void}
 */
function setSelectedFilter(window) {
  if (
    window.output.Request.Data != null &&
    window.output.Request.Data.Filters != null
  ) {
    for (let filter of window.output.Filters) {
      for (let i = 0; i < filter.Options.length; i++) {
        let option = filter.Options[i]

        if (
          option != null &&
          deepEqual(
            option.Value,
            window.output.Request.Data.Filters[filter.Target],
          )
        ) {
          filter.Selected = i
        }
      }
    }
  }
}

/** Table Hook */
class TableHook extends Hook {
  /**
   * Use dates on tables
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (window.output.Request.Prefix == "Multi") {
      if (
        window.output.Options &&
        window.output.Options.Filters_UseDate != null
      ) {
        window.filters.usedate = window.output.Options.Filters_UseDate
      } else if (
        $.inArray(window.output.Request.Subject, ignoreDateFilter) == -1
      ) {
        window.filters.usedate = true
      }
    }
  }
}

/** Date filter 'equals' hook */
class DateEqualsHook extends Hook {
  /**
   * Set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Options.Filters_UseDate == null ||
      !window.output.Options.Filters_UseDate.endsWith ||
      !window.output.Options.Filters_UseDate.endsWith(" =")
    ) {
      return
    }

    let filterTarget = window.output.Options.Filters_UseDate.slice(0, -2)
    let filterText = window.session.translations.Date
    if (
      window.output.Request.Data.Filters.hasOwnProperty(
        window.output.Options.Filters_UseDate,
      )
    ) {
      filterText =
        window.session.translations.Date +
        ": " +
        window.output.Request.Data.Filters[
          window.output.Options.Filters_UseDate
        ]
    }

    window.filters = {
      usedate: filterTarget,
      date: [
        {
          text: filterText,
          suffix: "=",
          value: null,
        },
      ],
      other: [],
      selectedOthers: 0,
    }
  }
}

/** Quotation hook */
class QuotationHook extends Hook {
  /**
   * Set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.Quotation" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Location: 1,
      Ranking: 0,
      Target: "Status",
      Text: null,
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusOpen,
          Value: "Open",
        },
        {
          Key: window.session.translations.StatusSent,
          Value: "Sent",
        },
        {
          Key: window.session.translations.StatusAccepted,
          Value: "Accepted",
        },
        {
          Key: window.session.translations.StatusOrder,
          Value: "Order",
        },
        {
          Key: window.session.translations.StatusRejected,
          Value: "Rejected",
        },
      ],
    })

    setSelectedFilter(window)
  }
}

/** Reservation Hook */
class ReservationHook extends Hook {
  /**
   * Set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.Reservation" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Target: "Status",
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusActive,
          Value: "Active",
        },
        {
          Key: window.session.translations.StatusOrder,
          Value: "Order",
        },
        {
          Key: window.session.translations.Expired,
          Value: "Expired",
        },
        {
          Key: window.session.translations.StatusRejected,
          Value: "Rejected",
        },
      ],
    })

    setSelectedFilter(window)
  }
}

/** Order hook */
class OrderHook extends Hook {
  /**
   * Set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.Order" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Target: "Status",
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusOpenPending,
          Value: ["Open", "Pending"],
        },
        {
          Key: window.session.translations.StatusOpen,
          Value: "Open",
        },
        {
          Key: window.session.translations.StatusPending,
          Value: "Pending",
        },
        {
          Key: window.session.translations.StatusClosed,
          Value: "Closed",
        },
        {
          Key: window.session.translations.StatusCancelled,
          Value: "Cancelled",
        },
      ],
    })

    // if the setting UsePick is true, add 2 statuses to filter on between "Open" and "Active"
    if (global.session.settings.UsePick) {
      window.output.Filters[0].Options.splice(2, 0, {
        Key: window.session.translations.StatusPick,
        Value: "Pick",
      })
      window.output.Filters[0].Options.splice(3, 0, {
        Key: window.session.translations.StatusPicked,
        Value: "Picked",
      })
    }

    setSelectedFilter(window)
  }
}

/** Pick hook */
class PickHook extends Hook {
  /**
   * set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.PickList" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Target: "Status",
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusOpen,
          Value: "Open",
        },
        {
          Key: window.session.translations.StatusPending,
          Value: "Pending",
        },
        {
          Key: window.session.translations.StatusClosed,
          Value: "Closed",
        },
      ],
    })

    setSelectedFilter(window)
  }
}

/** Invoice hook */
class InvoiceHook extends Hook {
  /**
   * set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.Invoice" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Target: "Status",
      Type: "List",
      Selected: 0,
      Options: [
        {
          Key: window.session.translations.StatusOpen,
          Value: "Open",
        },
        {
          Key: window.session.translations.StatusValidate,
          Value: "Validate",
        },
        {
          Key: window.session.translations.StatusSent,
          Value: "Sent",
        },
      ],
    })

    setSelectedFilter(window)
  }
}

/** Rental.vw_InvoiceProposal hook */
class VWInvoiceProposalHook extends Hook {
  /**
   * set correct filters
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (
      window.output.Request.Subject != "Rental.vw_InvoiceProposal" ||
      window.output.Request.Prefix != "Multi"
    ) {
      return
    }

    window.filters.usedate = "DateTimeNextInvoice"

    window.filters.date.forEach(function(dateFilter, index, dateFilterArray) {
      if (dateFilter.suffix == "<=") {
        let dateFilterValue = formatter.endOf("day")
        if (dateFilter.value != null) {
          dateFilterValue = formatter.endOf(
            "day",
            formatter.serializers.Date(dateFilter.value),
          )
          dateFilter.value = null
        } else if (
          window.input.Data.Filters[window.filters.usedate + " <="] != null
        ) {
          dateFilterValue =
            window.input.Data.Filters[window.filters.usedate + " <="]
        }

        dateFilter.text =
          session.translations.FilterDateEnd +
          ": " +
          formatter.parsers.Date(dateFilterValue)

        dateFilterArray[index] = dateFilter
      }
    })
  }
}

/** Rental.vw_ProposedSerialService Hook */
class VWProposedSerialServiceHook extends Hook {
  /**
   *
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (window.output.Request.Subject != "Rental.vw_ProposedSerialService") {
      return
    }

    /*window.filters.other = []
		window.filters.other.push({
			name: "Notificatie",
			suffix: "<=",
			type: "List",
			selected: 0, 
			list: [
				{
					text: "Alles"
				},
				{
					value: {
						DateTimeNotification1: formatter.serializers.Date(Date.now())
					},
					text: "Vanaf notificatie moment 1"
				},
				{
					value: {
						DateTimeNotification2: formatter.serializers.Date(Date.now())
					},
					text: "Vanaf notificatie moment 2"
				},
				{
					value: {
						DateTimeNotification3: formatter.serializers.Date(Date.now())
					},
					text: "Vanaf notificatie moment 3"
				}
			]
		})*/
  }
}

/** @ignore */
export default [
  new TableHook(),
  new DateEqualsHook(),
  new QuotationHook(),
  new ReservationHook(),
  new OrderHook(),
  new PickHook(),
  new InvoiceHook(),
  new VWInvoiceProposalHook(),
  new VWProposedSerialServiceHook(),
]
